import { render, staticRenderFns } from "./ResultsBox.vue?vue&type=template&id=4bfc545f&"
import script from "./ResultsBox.vue?vue&type=script&lang=js&"
export * from "./ResultsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports